import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const FAQ = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "Apakah News Hack cocok untuk trader pemula?",
      answer: "Ya, News Hack dirancang dengan metode yang simpel dan mudah diikuti bahkan untuk trader pemula. Kami menyediakan panduan step-by-step yang jelas dan dukungan konsultasi untuk memastikan Anda dapat menerapkannya dengan baik."
    },
    {
      question: "Berapa modal minimal untuk menerapkan teknik News Hack?",
      answer: "Untuk hasil optimal, kami menyarankan modal minimal $500. Namun, teknik ini juga bisa diterapkan dengan modal $200 dengan penyesuaian risk management yang tepat."
    },
    {
      question: "Berapa lama waktu yang dibutuhkan untuk mahir dengan teknik News Hack?",
      answer: "Mayoritas member kami sudah mulai mendapatkan profit konsisten setelah 2-3 minggu belajar dan praktik. Kami menyediakan simulasi trading untuk membantu Anda menguasai teknik ini lebih cepat."
    },
    {
      question: "Apakah ada biaya berlangganan bulanan?",
      answer: "Tidak ada biaya berlangganan bulanan. Anda hanya perlu membayar sekali untuk mendapatkan akses seumur hidup ke materi News Hack dan update-nya."
    },
    {
      question: "Berapa jam perhari yang dibutuhkan untuk trading dengan News Hack?",
      answer: "Salah satu keunggulan News Hack adalah efisiensi waktu. Anda hanya perlu trading pada saat rilis berita ekonomi penting (biasanya 1-2 jam). Anda tidak perlu menghabiskan berjam-jam di depan laptop untuk memantau chart."
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 100
      }
    }
  };

  const contentVariants = {
    hidden: { height: 0, opacity: 0 },
    visible: { 
      height: 'auto', 
      opacity: 1,
      transition: {
        duration: 0.3
      }
    }
  };

  return (
    <section className="py-20 gradient-bg" id="faq">
      <div className="container max-w-7xl mx-auto px-6">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.7 }}
          className="text-4xl md:text-5xl font-bold text-center mb-16"
        >
          Pertanyaan <span className="highlight">Yang Sering Ditanyakan</span>
        </motion.h2>
        
        <motion.div 
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          className="max-w-5xl mx-auto space-y-6"
        >
          {faqItems.map((item, index) => (
            <motion.div 
              key={index}
              variants={itemVariants}
              className="card-gradient border border-primary/20 rounded-xl overflow-hidden"
            >
              <div 
                className="flex justify-between items-center p-8 cursor-pointer font-semibold text-lg md:text-xl"
                onClick={() => toggleAccordion(index)}
              >
                <span>{item.question}</span>
                <motion.span
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                  </svg>
                </motion.span>
              </div>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div 
                    key={`content-${index}`}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={contentVariants}
                    className="overflow-hidden"
                  >
                    <div className="px-8 pb-8 pt-0 border-t border-white/10">
                      <p className="text-base md:text-lg leading-relaxed text-textGray">{item.answer}</p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ delay: 0.8, duration: 0.7 }}
          className="text-center mt-12"
        >
          <p className="mb-6">Masih punya pertanyaan lain?</p>
          <motion.a 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href="/checkout" 
            className="btn-primary text-white font-bold py-3 px-6 rounded-lg inline-block"
          >
            Daftar Sekarang
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;